export const EXTRA_GUARANTEE_PRICE = 'EXTRA-GUARANTEE-PRICE';
export const SKU_FOR_EXTRA_GUARANTEE = 'SKU-FOR-EXTRA-GUARANTEE';
export const PRODUCT_PRICE_FOR_EXTRA_GUARANTEE = 'PRODUCT-PRICE-FOR-EXTRA-GUARANTEE';
export const PRODUCT_NAME_FOR_EXTRA_GUARANTEE = 'PRODUCT-NAME-FOR-EXTRA-GUARANTEE';
export const PRODUCT_IMAGE_FOR_EXTRA_GUARANTEE = 'PRODUCT_IMAGE_FOR_EXTRA_GUARANTEE';
export const PARENT_SKU = 'parent_sku';
export const EXTRA_GUARANTEE_ATTRIBUTES = {
  EXCLUDED_BRANDS: 'extra-guarantee-excluded-brands',
  EXCLUDED_SKUS: 'extra-guarantee-excluded-skus',
  EXCLUDED_RELATIONS: 'extra-guarantee-excluded-relations',
  EXTRA_GUARANTEE_RATE: 'relative-price-rate',
  ENABLED_ON_MARKET: 'enabledOnMarket',
};
